module.exports = __webpack_public_path__ + "assets/img/UnderConstruction@2x.51f8aef3.png";